import { ExternalCalendarEvent } from './external-calendar-event';
import { Goal } from './goal';
import { ID } from './id';
import { TaskCardTask } from './task-card-task';
import { Timestamp } from './timestamp';

export type SectionItemBase = {
  id: ID;
};

export type SectionBase<Item extends SectionItemBase> = {
  id: ID;
  items: Item[];
};

export type GoalSection = SectionBase<TaskCardTask> & {
  frozen?: boolean;
};

export type DateSection<Item extends SectionItemBase> = SectionBase<Item> & {
  startDate: Timestamp;
  endDate: Timestamp;
};

export type TaskCardDateSection = DateSection<TaskCardTask> & {
  deadline: Timestamp;
  type: DateSectionOptions;
  isDroppableOnly?: boolean;
  externalEvents?: ExternalCalendarEvent[];
};

export type TaskCardTimeSection = SectionBase<TaskCardTask> & {
  startTime: number | null;
};

export type GoalDateSection = DateSection<Goal>;

export enum DateSectionOptions {
  Day = 'day',
  RestOfMonth = 'rest-of-month',
  Month = 'month',
  Year = 'year',
}

export const overdueSectionID = 'overdue';

export type OverdueSectionID = typeof overdueSectionID;

export const otherSectionID = 'other-section';

export type OtherSectionID = typeof otherSectionID;

export const goalInboxID = 'inbox';

export type GoalInboxID = typeof goalInboxID;

export const lifeAreaOtherID = 'other';

export type LifeAreaOtherID = typeof lifeAreaOtherID;

export const unlinkedPlannedTasksID = 'unlinked-planned-tasks';

export type UnlinkedPlannedTasksID = typeof unlinkedPlannedTasksID;

export const untaggedId = 'untagged';

export type UntaggedId = typeof untaggedId;
